
<app-hospital-profile *ngIf="selectedAccountType?.accountType?.name =='Organization'"
    [endCustomerData]="endCustomerData" (onUpdateEvent)="onUpdateEvent($event)"
    [hospitalForm]="endCustomerEditForm"></app-hospital-profile>
<app-doctor-profile *ngIf="selectedAccountType?.accountType?.name =='Individual'" [doctorForm]="endCustomerEditForm"
    [endCustomerData]="endCustomerData" [jobPost]="jobPost"
    (onUpdateEvent)="onUpdateEvent($event)"></app-doctor-profile>